export default "__VITE_ASSET__3457ef00__"